/**
 * Relative refresh age for data-source toolbar controls (displayed in whole hours).
 */

/** Show refresh call-to-action when last refresh is older than this (whole hours). */
export const REFRESH_STALE_AFTER_HOURS = 24;

/**
 * Whole hours since `isoOrDate`, or null if invalid/missing.
 * Future timestamps are treated as 0.
 */
export function getRefreshAgeHours(isoOrDate) {
  if (isoOrDate == null || isoOrDate === "") return null;
  const t = new Date(isoOrDate).getTime();
  if (!Number.isFinite(t)) return null;
  const diffMs = Date.now() - t;
  if (diffMs <= 0) return 0;
  return Math.floor(diffMs / (60 * 60 * 1000));
}

/** Human segment for toolbar label, e.g. "<1h" or "3h". */
export function formatRefreshAgeHours(isoOrDate) {
  const hours = getRefreshAgeHours(isoOrDate);
  if (hours == null) return null;
  if (hours < 1) return "<1h";
  return `${hours}h`;
}

/** True when never refreshed or last refresh is at least {@link REFRESH_STALE_AFTER_HOURS} hours ago. */
export function isDataRefreshStale(isoOrDate) {
  const hours = getRefreshAgeHours(isoOrDate);
  if (hours == null) return true;
  return hours >= REFRESH_STALE_AFTER_HOURS;
}

/** @param {string|Date|null|undefined} isoOrDate */
export function formatDataRefreshStatusLabel(isoOrDate) {
  const age = formatRefreshAgeHours(isoOrDate);
  if (!age) return "Updated —";
  return `Updated ${age} ago`;
}
